import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import UserAuthStore from "../modules/user/auth/store/UserAuthStore";
import WhitePaperStore from "../modules/white-paper/store/WhitePaperStore";
import ConsensusStore from "@/modules/consensus-report/store/ConsensusStore";
import UserProviders from "@/modules/user/auth/providers/UserProviders";
import HistoricalDataStore from "@/modules/historical-data-visualization/store/VisualizationStore";
import ForeCastStore from "@/modules/forecast-tool/store/ForeCastStore";
import ShortTermSore from "@/modules/short-term/store/ShortTermStore";
import CountryTablesStore from "@/modules/country-tables/store/CountryTablesStore";
import TradingStrategyStore from "@/modules/trading-strategy/store/TradingStrategyStore";

export default createStore({
  state: {
    data_update: "",
    tab: 1,
  },
  getters: {
    getDateUpdate(state) {
      return state.data_update;
    },
    getTab(state) {
      return state.tab;
    },
  },
  mutations: {
    SET_DATE_UPDATE(state, data) {
      state.data_update = data;
    },
    SET_TAB(state, tab) {
      state.tab = tab;
    },
  },
  actions: {
    setDateUpdate({ commit }) {
      UserProviders.getDateUpdate().then((data) => {
        commit("SET_DATE_UPDATE", data.data.lastUpdate.date);
      });
    },
    setTab({ commit }, tab) {
      commit("SET_TAB", tab);
    },
  },
  modules: {
    auth: UserAuthStore,
    whitePaper: WhitePaperStore,
    consensus: ConsensusStore,
    historicalData: HistoricalDataStore,
    forecast: ForeCastStore,
    ShortTermSore: ShortTermSore,
    CountryTablesStore,
    tradingStrategy: TradingStrategyStore,
  },
  plugins: [
    createPersistedState({
      key: "janus",
      paths: ["auth"],
      reducer: (state) => ({
        auth: {
          access_token: state.auth.access_token,
          me: state.auth.me,
        },
      }),
    }),
  ],
});
